import { FormControl, Grid, InputLabel, MenuItem, StandardTextFieldProps, TextField, Typography } from "@mui/material";
import { useUser } from "../../Hooks/useUser";
import { useAppSelector } from "../../Redux/store";
import { NodeEvironments, ProfileType, africanCountries, allCountries } from "../../Types/General";
import { AppSettings } from "../../Utils/Settings";

interface KaziCountriesProps extends StandardTextFieldProps {
    showLabel?: boolean;
}
export const KaziCountries = (props:KaziCountriesProps) => {
    /* ******************** Hooks ******************** */
    const { type } = useUser();
    /* ******************** Variables ******************** */
    const profileType = useAppSelector( state => state.AccountCreation.ProfileType);
    const isLoggedIn = useAppSelector( state => state.Global.isLoggedIn);
    const showAllCountries = isLoggedIn ? type == ProfileType.Client : profileType == ProfileType.Client;
    //@ts-ignore
    const talentCountries = AppSettings.NodeEnvironment !== NodeEvironments.Production ?  africanCountries.concat([{ Label: 'United States(only available in test environments)', Country: 'United States', YvCode: 'us' }]) : africanCountries
    /* ******************** Functions ******************** */
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <Grid display={'flex'} flexDirection={'column'} width={'100%'} flex={1}>
            {props.showLabel && <Typography variant='body-small' color={'black.200'} marginBottom={1}>Country</Typography>}
            <FormControl>   
                <InputLabel sx={{opacity: 1, color: 'primary.main'}}>{props.value ?"":"Country"}</InputLabel>
                <TextField   
                    {...props}     
                    placeholder="Country"
                    select
                >
                    {
                        showAllCountries ?
                        allCountries.map((country) => (
                            <MenuItem key={country} value={country}>
                                {country}
                            </MenuItem>
                        )):
                        talentCountries.map((country) => (
                            <MenuItem key={country.Country} value={country.Country} >
                                {/** @ts-ignore */}
                                {country?.Label ?? country.Country}
                            </MenuItem>
                        ))
                    }
                </TextField>
            </FormControl>
        </Grid>
    )
}